import React from "react";
import { IconKingLogo } from "../icons";
import Button from "../form/Button";
import iconPge from "../../assets/icon-pge.png";
import { ArrowsRightLeftIcon } from "@heroicons/react/24/outline";

interface Props {
	children: React.ReactNode;
}

const CoreLayout: React.FC<Props> = ({ children }) => {
	return (
		<div className="w-full max-w-[550px] relative mx-auto">
			<div className="w-full h-screen md:h-min p-0 md:p-5 left-0 top-0 absolute inline-flex justify-start items-center gap-2.5">
				<div className="self-stretch w-full bg-white rounded-[5px] outline outline-1 outline-offset-[-1px] outline-neutral-200 inline-flex flex-col justify-start items-start overflow-hidden">
					<div className="h-[700px] max-h-[700px] min-h-[700px] w-full flex-1 p-2 sm:p-3 md:p-5 relative flex flex-col justify-start items-start gap-5 overflow-hidden">
						<div className="self-stretch p-2 inline-flex justify-center items-center gap-3">
							<IconKingLogo className="h-8 w-auto" />
							<ArrowsRightLeftIcon className="h-6 w-auto" />
							<img className="h-10 w-auto" src={iconPge} alt="PG&E Logo" />
						</div>
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CoreLayout;
